module.exports = __webpack_public_path__ + "images/views/landingPage/tall-logo_ppa-6726d827f386dd2e1b4e87b822ea983b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/landingPage/tall-logo_ppa.svg
// module id = 2536
// module chunks = 2